import { api } from 'src/common/fetch';

import type {
  ForgeAccountDiagnostics,
  ForgeRegionMismatchScan,
  ForgeToken,
} from './types';

export async function getForgeViewerToken() {
  return api.get<ForgeToken>('/api/forge/token/viewer');
}

export async function getForgeAccountDiagnostics(urnEncoded?: string) {
  const query = urnEncoded ? `?urn=${encodeURIComponent(urnEncoded)}` : '';
  return api.get<ForgeAccountDiagnostics>(`/api/forge/diagnostics${query}`);
}

export async function getForgeRegionMismatchScan(options?: {
  projectId?: string;
  limit?: number;
}) {
  const params = new URLSearchParams();
  if (options?.projectId) {
    params.set('projectId', options.projectId);
  }
  if (options?.limit !== undefined) {
    params.set('limit', String(options.limit));
  }
  const query = params.toString();
  return api.get<ForgeRegionMismatchScan>(
    `/api/forge/diagnostics/region-mismatch${query ? `?${query}` : ''}`,
  );
}

export async function getProperties(
  projectId: string,
  fileId: string,
  fileVersionId: string,
  fileVersionViewId: string,
  includePaths = false,
) {
  return api.get<string[]>(
    `/api/projects/${projectId}/files/${fileId}/versions/${fileVersionId}/views/${fileVersionViewId}/properties?includePaths=${includePaths.toString()}`,
  );
}

export async function getCategoryValues(
  projectId: string,
  fileId: string,
  fileVersionId: string,
  fileVersionViewId: string,
) {
  return api.get<string[]>(
    `/api/projects/${projectId}/files/${fileId}/versions/${fileVersionId}/views/${fileVersionViewId}/categories`,
  );
}

export async function getParamValues(
  projectId: string,
  fileId: string,
  fileVersionId: string,
  fileVersionViewId: string,
  param: string,
) {
  const query = `key=${encodeURI(param)}`;
  return api.get<string[]>(
    `/api/projects/${projectId}/files/${fileId}/versions/${fileVersionId}/views/${fileVersionViewId}/values?${query}`,
  );
}
